import { inject, Injectable } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";

@Injectable({
    providedIn: 'root',
})
export class CustomDialogService {
    private dialogService = inject(DialogService);
    ref: DynamicDialogRef | null | undefined;
    
    dialogConfig = {
        width: '600px',
        height: 'auto',
        modal: true,
        closable: true,
        closeOnEscape: true,
        dismissableMask: false,
        draggable: false,
        resizable: false,
        focusOnShow: false
    };

    openDialog(component: any, config?: any) {
        this.ref = this.dialogService.open(component, {
            ...this.dialogConfig,
            ...config
        });
    }

}